import React, { useEffect, useState } from 'react';
import './register.css';

const cities = [
  { name: 'Noida', active: false, status: 'ended' },
  { name: 'All India', active: true, link: 'https://docs.google.com/forms/d/e/1FAIpQLSfMErOzG2FsyTaSiE2qbuWQKerxNrjo3GmizPPnVRXa2-iDYg/viewform' },
  { name: 'Jaipur', active: false, status: 'ended' },
  { name: 'Prayagraj', active: false, status: 'ended' },
  { name: 'Patna', active: false, status: 'ended' },
  { name: 'Lucknow & Kanpur', active: false, status: 'ended' },
  { name: 'Bhopal', active: false, status: 'ended' },
];

export default function Register() {
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleDisabledClick = (e, status) => {
    e.preventDefault();
    if (status === 'ended') {
      setModalMessage("Registrations have ended.");
    } else {
      setModalMessage("Registrations have not started yet, stay tuned.");
    }
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className="register-container">
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>{modalMessage}</h3>
            <button className="modal-close-btn" onClick={closeModal}>Close</button>
          </div>
        </div>
      )}

      <div className="register-content">
        <h1 className="register-title">REGISTER NOW</h1>
        <p className="register-subtitle">Select your city to register for the upcoming events.</p>
        <div className="register-grid">
          {cities.map((city, index) => (
            city.active ? (
              <a
                key={index}
                href={city.link}
                target="_blank"
                rel="noopener noreferrer"
                className="register-card active-card"
              >
                <div className="card-content">
                  <h2>{city.name}</h2>
                  <span className="status">Open</span>
                </div>
              </a>
            ) : (
              <div
                key={index}
                className="register-card disabled-card"
                onClick={(e) => handleDisabledClick(e, city.status)}
                title={city.status === 'ended' ? "Registrations have ended." : "Registrations have not started yet, stay tuned."}
              >
                <div className="card-content">
                  <h2>{city.name}</h2>
                  <span className="status">{city.status === 'ended' ? 'Ended' : 'Stay Tuned'}</span>
                </div>
              </div>
            )
          ))}
        </div>
      </div>
    </div>
  );
}